import * as Toolkit from '../../../toolkit/index';
import * as UIToolkit from '../../../UIToolkit/index';
import * as Utils from '../../../utils/util';
import * as FrontCubeData from '../../../frontCubeData/index';

// 渲染货架title和货架id
export function setShelfTitleStyle(cube: CubeNode): void {
    let shelfTitle: string = FrontCubeData.getValue(cube.id, 'displayUnit') || '';
    let shelfId: string = FrontCubeData.getValue(cube.id, 'shelfId') || '';
    let height: number = UIToolkit.getPXSizeValue(cube.id, 'height');

    Toolkit.html(cube.jView.find('.J_BoxId'), `${shelfId}`);
    Toolkit.html(cube.jView.find('.J_BoxTitle'), shelfTitle);
    cube.jView.find('.shelves-box-title').css('bottom', height + 100);
}
